export type DriverOption = {
  id: number;
  name: string;
  is_on_duty?: boolean;
  last_lat?: number | null;
  last_lng?: number | null;
  last_ping_at?: string | null;
};

export type DriverPanelTab = "on" | "off";

export type DriverMapFocus = {
  id: number;
  name: string;
  lat: number;
  lng: number;
};

export type DriverLocationRecord = {
  id: number;
  name: string;
  last_lat?: number | false | null;
  last_lng?: number | false | null;
  last_ping_at?: string | false | null;
};

export function hasDriverLocation(driver: DriverOption): boolean {
  const lat = driver.last_lat;
  const lng = driver.last_lng;
  return (
    typeof lat === "number" &&
    typeof lng === "number" &&
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180
  );
}

export function toDriverMapFocus(driver: DriverOption): DriverMapFocus | null {
  if (!hasDriverLocation(driver)) {
    return null;
  }
  return {
    id: driver.id,
    name: driver.name,
    lat: driver.last_lat as number,
    lng: driver.last_lng as number,
  };
}
